export default "/images/loader.svg?37000a78074176dcb69efdee285f008a";